var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operate-column-wrapper"},[_c('Icon',{attrs:{"width":"21","height":"18","bgPosition":_vm.chatPosition,"hoverBgPosition":_vm.chatHoverPosition},on:{"iconClick":_vm.clickHandle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }